<script>
export default {
  name: 'Blank',
}
</script>

<template>
  <nuxt />
</template>

<style scoped></style>
